import {
  DestinationAdGroup,
  DestinationInstance,
  DestinationSource,
  DestinationType,
} from '@app/criterion-addition/shared/models/destination.models';
import { ApiGetAction } from '@app/core/store/models/api-action.models';
import { DestinationGetParams } from '@app/core/api/customers/criterion-addition/destination-type-api.service';
import { CompositeId } from '@app/core/models/common.models';

export class InitDestinations {
  static type = '[Destination] Init';

  constructor(readonly source: DestinationSource) {}
}

export class GetDestinationTypes {
  static type = '[Destination] Get Types';

  constructor(readonly params: DestinationGetParams) {}
}

export class GetDestinationAdGroups extends ApiGetAction<DestinationAdGroup> {
  static type = '[Destination] Get Ad Groups';
}

export class GetSelectedAdGroups {
  static type = '[Destination] Get Selected Ad Groups';

  constructor(readonly adGroupIds: CompositeId[]) {}
}

export class SelectDestination {
  static type = '[Destination] Select';

  constructor(readonly destinationType: DestinationType) {}
}

export class DeselectDestination {
  static type = '[Destination] Deselect';

  constructor(readonly destinationType: DestinationType) {}
}

export class SelectAdGroup {
  static type = '[Destination] Select Ad Group';

  constructor(readonly adGroup: DestinationAdGroup) {}
}

export class DeselectAdGroup {
  static type = '[Destination] Deselect Ad Group';

  constructor(readonly adGroup: DestinationAdGroup) {}
}

export class SelectMatchType {
  static type = '[Destination] Select Match Type';

  constructor(readonly destination: DestinationInstance) {}
}

export class DeselectMatchType {
  static type = '[Destination] Deselect Match Type';

  constructor(readonly destination: DestinationInstance) {}
}

export class DestinationUpdated {
  static type = '[Destination] Updated';
}
